// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transport-card {
  background: var(--etaeta-color-accent);
  border-radius: 0.5rem;
  padding: 20px 16px;
  display: flex;
  flex-flow: row;
  gap: 16px;
}
.transport-card:hover {
  background: var(--etaeta-color-accent-hover);
}
.transport-card .decor {
  display: flex;
  flex-flow: column;
  align-items: center;
  text-align: center;
  gap: 4px;
  color: var(--eta-color-theme);
}
.transport-card .decor .icon {
  width: 11px;
}
.transport-card .decor .line {
  flex: 1;
  position: relative;
  isolation: isolate;
  width: 11px;
  background-image: radial-gradient(var(--eta-color-theme) 2px, transparent 0);
  background-size: 11px 11px;
}
.transport-card .title {
  color: var(--eta-color-theme);
}
.transport-card .body {
  display: flex;
  flex-flow: column;
  gap: 10px;
  flex: 1;
}
.transport-card .body p {
  line-height: normal;
  font-weight: 400;
  margin: 0;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: end;
}
.transport-card .body p:nth-child(1) {
  color: #0088ff;
  align-items: start;
}
.transport-card .body p.following {
  color: #8c8c8c;
}
.transport-card .body p .number {
  font-size: 18px;
}
.transport-card .body p .number.active {
  color: #42a73b;
}
.transport-card .body p .time {
  font-weight: 600;
  margin-inline-end: 4px;
}
/*# sourceMappingURL=TransportListItem.css.map */`, "",{"version":3,"sources":["webpack://./TransportListItem.less","webpack://./src/components/TransportList/components/TransportListItem/TransportListItem.less"],"names":[],"mappings":"AAAA;EACI,sCAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,SAAA;ACCJ;ADCI;EACI,4CAAA;ACCR;ADVA;EAaQ,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,6BAAA;ACAR;ADlBA;EAsBY,WAAA;ACDZ;ADrBA;EA0BY,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,4EAAA;EACA,0BAAA;ACFZ;AD7BA;EAoCQ,6BAAA;ACJR;ADhCA;EAwCQ,aAAA;EACA,iBAAA;EACA,SAAA;EACA,OAAA;ACLR;ADtCA;EA8CY,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,gBAAA;ACLZ;ADOY;EACI,cAAA;EACA,kBAAA;ACLhB;ADQY;EACI,cAAA;ACNhB;ADtDA;EAgEgB,eAAA;ACPhB;ADSgB;EACI,cAAA;ACPpB;AD5DA;EAwEgB,gBAAA;EACA,sBAAA;ACThB;AACA,gDAAgD","sourcesContent":[".transport-card {\n    background: var(--etaeta-color-accent);\n    border-radius: .5rem;\n    padding: 20px 16px;\n    display: flex;\n    flex-flow: row;\n    gap: 16px;\n\n    &:hover {\n        background: var(--etaeta-color-accent-hover);\n    }\n\n    .decor {\n        display: flex;\n        flex-flow: column;\n        align-items: center;\n        text-align: center;\n        gap: 4px;\n        color: var(--eta-color-theme);\n\n\n        .icon {\n            width: 11px;\n        }\n\n        .line {\n            flex: 1;\n            position: relative;\n            isolation: isolate;\n            width: 11px;\n            background-image: radial-gradient(var(--eta-color-theme) 2px, transparent 0);\n            background-size: 11px 11px;\n        }\n    }\n\n    .title {\n        color: var(--eta-color-theme);\n    }\n\n    .body {\n        display: flex;\n        flex-flow: column;\n        gap: 10px;\n        flex: 1;\n\n        p {\n            line-height: normal;\n            font-weight: 400;\n            margin: 0;\n            display: flex;\n            flex-flow: row nowrap;\n            justify-content: space-between;\n            align-items: end;\n\n            &:nth-child(1) {\n                color: #0088ff;\n                align-items: start;\n            }\n\n            &.following {\n                color: rgb(140 140 140);\n            }\n\n            .number {\n                font-size: 18px;\n\n                &.active {\n                    color: rgb(66 167 59);\n                }\n            }\n\n            .time {\n                font-weight: 600;\n                margin-inline-end: 4px;\n            }\n        }\n    }\n}",".transport-card {\n  background: var(--etaeta-color-accent);\n  border-radius: 0.5rem;\n  padding: 20px 16px;\n  display: flex;\n  flex-flow: row;\n  gap: 16px;\n}\n.transport-card:hover {\n  background: var(--etaeta-color-accent-hover);\n}\n.transport-card .decor {\n  display: flex;\n  flex-flow: column;\n  align-items: center;\n  text-align: center;\n  gap: 4px;\n  color: var(--eta-color-theme);\n}\n.transport-card .decor .icon {\n  width: 11px;\n}\n.transport-card .decor .line {\n  flex: 1;\n  position: relative;\n  isolation: isolate;\n  width: 11px;\n  background-image: radial-gradient(var(--eta-color-theme) 2px, transparent 0);\n  background-size: 11px 11px;\n}\n.transport-card .title {\n  color: var(--eta-color-theme);\n}\n.transport-card .body {\n  display: flex;\n  flex-flow: column;\n  gap: 10px;\n  flex: 1;\n}\n.transport-card .body p {\n  line-height: normal;\n  font-weight: 400;\n  margin: 0;\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  align-items: end;\n}\n.transport-card .body p:nth-child(1) {\n  color: #0088ff;\n  align-items: start;\n}\n.transport-card .body p.following {\n  color: #8c8c8c;\n}\n.transport-card .body p .number {\n  font-size: 18px;\n}\n.transport-card .body p .number.active {\n  color: #42a73b;\n}\n.transport-card .body p .time {\n  font-weight: 600;\n  margin-inline-end: 4px;\n}\n/*# sourceMappingURL=TransportListItem.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
